import { AuditUser } from "./auditUser"

export interface BaseAudit {
	id: string
	oldValue: string | null
	newValue: string | null
	oldValueLabel: string | null
	newValueLabel: string | null
	fieldName: string | null
	fieldId: string | null
	changedBy: AuditUser
	changedAt: string
	text: string
}

export interface SystemAudit extends BaseAudit {
	objectType: string
	objectTitle: string | null
}

export enum SystemAuditType {
	// Setup sections
	Field = "Field",
	Folder = "Folder",
	Template = "Template",
	DataSource = "List",
	DataSourceItem = "Item",
	Definition = "Definition",
	Area = "Area",
	Format = "Format",
	Rule = "Rule",
	Tag = "Tag",
	View = "View",
	TenantInfo = "TenantInfo",
	UserUpdate = "UserUpdate",

	// Users
	User = "User",
	Team = "Team",
	UserFields = "User Fields",

	// Admin settings
	CaseNameSetting = "Case Name Setting",
	RecordNameSetting = "Record Name Setting",
	Severity = "Severity",
	Status = "Status",
	TenantSetting = "Setting",
	UserStatus = "User Status",

	// Dashboard
	Dashboard = "Dashboard",
	DashboardCell = "Dashboard Cell",
	Noticeboard = "Noticeboard",
	Note = "Notes",

	// Misc
	Schedule = "Schedule",
	ScheduleSettings = "ScheduleSettings",
	Insight = "Insight",
	InsightParameter = "InsightParameter",
	CadenceInstance = "Cadence Instance",
}

export const SystemAuditTypeLabels: { [key in SystemAuditType]: string } = {
	[SystemAuditType.Field]: "Field",
	[SystemAuditType.Folder]: "Folder",
	[SystemAuditType.Template]: "Template",
	[SystemAuditType.DataSource]: "Data Source",
	[SystemAuditType.DataSourceItem]: "Data Source Item",
	[SystemAuditType.Definition]: "Definition",
	[SystemAuditType.Area]: "Area",
	[SystemAuditType.Format]: "Format",
	[SystemAuditType.Rule]: "Rule",
	[SystemAuditType.Tag]: "Tag",
	[SystemAuditType.View]: "View",
	[SystemAuditType.TenantInfo]: "Tenant Info",
	[SystemAuditType.UserUpdate]: "User Update",
	[SystemAuditType.User]: "User",
	[SystemAuditType.Team]: "Role",
	[SystemAuditType.UserFields]: "User Fields",
	[SystemAuditType.CaseNameSetting]: "Case Name Setting",
	[SystemAuditType.RecordNameSetting]: "Record Name Setting",
	[SystemAuditType.Severity]: "Severity",
	[SystemAuditType.Status]: "Status",
	[SystemAuditType.TenantSetting]: "Setting",
	[SystemAuditType.UserStatus]: "User Status",
	[SystemAuditType.Dashboard]: "Dashboard",
	[SystemAuditType.DashboardCell]: "Dashboard Cell",
	[SystemAuditType.Noticeboard]: "Noticeboard",
	[SystemAuditType.Note]: "Notes",
	[SystemAuditType.Schedule]: "Schedule",
	[SystemAuditType.ScheduleSettings]: "ScheduleSettings",
	[SystemAuditType.Insight]: "Insight",
	[SystemAuditType.InsightParameter]: "Insight Parameter",
	[SystemAuditType.CadenceInstance]: "Cadence Instance"
}
